import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';

import { applyColor }from '~src/style/ColorService';

import { cssClass } from '../../style';

const cssPrefix = 'Home';

export namespace HomeStyles {

  export const root = cssClass(cssPrefix, 'root', {
    fontWeight: 'normal',
    margin: '32px 24px 0',
    position: 'relative',
    overflowX: 'hidden'
  });

  export const pageHeader = cssClass(cssPrefix, 'page-header', {
    marginBottom: 44,
    $nest: {
      '& h1': {
        fontWeight: 'normal',
        color: applyColor(DesignTokens.color.font.default.default, TabStyles.Colors.L9),
        fontSize: TabStyles.Typography.Sizing.XXLarge,
        margin: 0,
        lineHeight: 1
      }
    }
  });

  export const contentSectionMargin = 56;

  export const contentSection = cssClass(cssPrefix, 'content-section', {
    marginBottom: contentSectionMargin
  });

  export const createButton = cssClass(cssPrefix, 'create-button', {
    position: 'absolute',
    top: '0',
    right: '0',
  });

}
